import { FC, ElementType } from 'react';
import Button from '../Button/Button';
import Stack from '../Stack/Stack';
import './ButtonGroup.css';

interface ButtonGroupProps {
  options: { label: string; value: string }[];
  value: string | string[];
  onChange: (value: string | string[]) => void;
  className?: string;
  gap?: 'no' | 'xs' | 'sm' | 'md' | 'lg';
  multiSelect?: boolean;
}

const ButtonGroup: FC<ButtonGroupProps> = ({ 
  options, 
  value, 
  onChange, 
  className = '', 
  gap = 'no',
  multiSelect = false 
}) => {
  const handleClick = (clickedValue: string) => {
    if (!multiSelect) {
      onChange(clickedValue);
      return;
    }

    // Handle multiselect logic
    const currentValues = Array.isArray(value) ? value : [];
    if (currentValues.includes(clickedValue)) {
      // Remove value if already selected
      onChange(currentValues.filter(v => v !== clickedValue));
    } else {
      // Add value if not selected
      onChange([...currentValues, clickedValue]);
    }
  };

  const isSelected = (optionValue: string) => {
    if (multiSelect) {
      return Array.isArray(value) && value.includes(optionValue);
    }
    return optionValue === value;
  };

  return (
    <Stack direction="horizontal" className={`button-group ${className}`} gap={gap}>
      {options.map((option) => (
        <Button
          key={option.value}
          onClick={() => handleClick(option.value)}
          className={isSelected(option.value) ? 'active' : ''}
        >
          {option.label}
        </Button>
      ))}
    </Stack>
  );
};

export default ButtonGroup;
